import styled from "../../theme";
export const TermMessage = styled.div`
    text-align: center;
    font-size: 0.8em;
    font-weight: 600;
    margin-bottom: 1em;
`;
